
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Retargeting Instagram Ads : reconquérir vos prospects facilement",
    description:
      "Découvrez le pouvoir du retargeting sur Instagram Ads pour reconquérir vos prospects et booster vos conversions. ALEO vous accompagne dans cette stratégie !",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
